import React from 'react';
import { Badge } from '@tonic/shared/components/ui';
import { cn } from '@tonic/shared/utils/lib/utils';
import PropTypes from 'prop-types';

export function StatusBadge({ status, className, ...props }) {
  const getStatusConfig = (status) => {
    const configs = {
      new: {
        label: 'New',
        className: 'bg-blue-100 text-blue-800'
      },
      in_recommerce: {
        label: 'In Re-Commerce',
        className: 'bg-yellow-100 text-yellow-800'
      },
      repaired: {
        label: 'Repaired',
        className: 'bg-green-100 text-green-800'
      },
      awaiting_refill: {
        label: 'Awaiting Refill',
        className: 'bg-orange-100 text-orange-800'
      },
      out_of_stock: {
        label: 'Out of Stock',
        className: 'bg-red-100 text-red-800'
      },
      scrapped: {
        label: 'Scrapped',
        className: 'bg-gray-100 text-gray-800'
      },
      on_rental: {
        label: 'On Rental',
        className: 'bg-purple-100 text-purple-800'
      },
      active: {
        label: 'Active',
        className: 'bg-green-100 text-green-800'
      },
      discontinued: {
        label: 'Discontinued',
        className: 'bg-red-100 text-red-800'
      },
      draft: {
        label: 'Draft',
        className: 'bg-gray-100 text-gray-800'
      }
    };

    return configs[status] || {
      label: status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
      className: 'bg-gray-100 text-gray-800'
    };
  };

  const config = getStatusConfig(status);

  return (
    <Badge
      className={cn(config.className, className)}
      {...props}
    >
      {config.label}
    </Badge>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string
}; 